import React, { useState } from 'react';
import ModernLogo from './header/modern_logo';
import ModernPesquisar from './header/modern_pesquisar';
import ModernCartSidebar from './modern_cart_sidebar';
import backgroundImage from "../assets/images/bg-imaginarium.png";

function ModernHeader({ callback, cartItems = [], onCartClick }) {
  const [searchVisible, setSearchVisible] = useState(false);
  const [cartVisible, setCartVisible] = useState(false);

  const handleCartClick = () => {
    if (onCartClick) {
      onCartClick();
    } else {
      setCartVisible(true);
    }
  };

  // --- LÓGICA MODIFICADA ---
  const loginData = sessionStorage.getItem('login');
  console.log('Dados de login:', loginData); // Log para depuração
  console.log('Dados de login:', sessionStorage); // Log para depuração
  const isLoggedIn = !!loginData; // Converte para booleano (true se existir, false se não)
  
  // Verifica se é franqueado (baseado na lógica de PedidosLoja.js e do seu debug)
  const isFranqueado = isLoggedIn && loginData.includes('/');
  
  // Define o link de "Meus Pedidos"
  const pedidosHref = isFranqueado ? '/pedidos_loja' : '/pedidos_cliente';
  // --- FIM DA LÓGICA ---

  return (
    <>
      {/* Header principal */}
      <header className="modern-header" style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="container-fluid">
          <nav className="navbar navbar-expand-lg">
            <div className="row align-items-center" id="modern-header-row">
              {/* Logo - Mobile e Desktop */}
              <div className="col-4 col-md-3">
                <ModernLogo />
              </div>

              {/* Barra de pesquisa - Desktop */}
              <div className="col-md-6 d-none d-md-block">
                <ModernPesquisar callback={callback} />
              </div>

              {/* Ações - Mobile e Desktop */}
              <div className="col-8 col-md-3 d-flex justify-content-end align-items-center gap-2">
                {/* Botão de pesquisa - Mobile */}
                <button
                  className="btn modern-header-icon d-flex align-items-center justify-content-center"
                  onClick={() => setSearchVisible(!searchVisible)}
                  aria-label="Pesquisar"
                  id="modern-search-button"
                >
                  <i className="bi bi-search"></i>
                </button>

                {/* Container para botões do header */}
                <div className="d-flex align-items-center gap-2">
                  {/* Botão do carrinho/sacola */}
                  <button
                    className="btn modern-header-icon position-relative"
                    onClick={handleCartClick}
                    aria-label="Carrinho de compras"
                  >
                    <i className="bi bi-bag"></i>
                    {cartItems.length > 0 && (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        {cartItems.length}
                      </span>
                    )}
                  </button>

                  {/* Botão de login/perfil */}
                  {isLoggedIn ? (
                    <div className="dropdown">
                      <button 
                        className="btn modern-header-icon dropdown-toggle" 
                        type="button" 
                        data-bs-toggle="dropdown"
                        aria-label="Menu do usuário"
                      >
                        <i className="bi bi-person-circle"></i>
                      </button>
                      <ul className="dropdown-menu dropdown-menu-end">
                        
                        {/* --- LINK MODIFICADO --- */}
                        <li><a className="dropdown-item" href={pedidosHref}>
                          <i className="bi bi-bag me-2"></i>Meus Pedidos
                        </a></li>
                        {/* --- FIM DA MODIFICAÇÃO --- */}

                        {/* <li><a className="dropdown-item" href="/favoritos">
                          <i className="bi bi-heart me-2"></i>Favoritos
                        </a></li> */}
                        <li><a className="dropdown-item" href="/trocar_senha">
                          <i className="bi bi-key me-2"></i>Trocar Senha
                        </a></li>
                        <li><hr className="dropdown-divider" /></li>
                        <li><button className="dropdown-item" onClick={() => {
                          // Salvar ID da loja antes de limpar
                          const idLoja = sessionStorage.getItem('loja');

                          // Limpar apenas dados do usuário, mantendo dados da loja
                          sessionStorage.removeItem('login');
                          sessionStorage.removeItem('usuario_id');
                          sessionStorage.removeItem('comprar');

                          // Redirecionar mantendo a mesma loja
                          window.location.href = idLoja ? `/?id=${idLoja}` : '/';
                        }}>
                          <i className="bi bi-box-arrow-right me-2"></i>Sair
                        </button></li>
                      </ul>
                    </div>
                  ) : (
                    <button
                      className="btn modern-header-icon"
                      onClick={() => window.location.href = '/login'}
                      aria-label="Fazer login"
                    >
                      <i className="bi bi-person"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Barra de pesquisa expandida - Mobile */}
            {searchVisible && (
              <div className="row w-100 mt-3 d-md-none transition-search">
                <div className="col-12">
                  <ModernPesquisar callback={callback} />
                </div>
              </div>
            )}
          </nav>
        </div>
      </header>

      {/* Sidebar do carrinho */}
      <ModernCartSidebar
        isOpen={cartVisible}
        onClose={() => setCartVisible(false)}
        cartItems={cartItems}
        onUpdateCart={() => {}}
      />
    </>
  );
}

export default ModernHeader;